var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"landing-wrapper d-flex justify-content-center",style:({ width: '100vw', minHeight: '100vh' })},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center d-flex flex-column align-items-center justify-content-center"},[_c('h1',{staticClass:"text-danger mt-0 mb-0"},[_vm._v("404")]),_c('h4',[_vm._v("Page not found")])])
}]

export { render, staticRenderFns }